import React, { Component } from 'react';
import Modal from '../../containers/common/Modal';
import styled from 'styled-components';

import { FadeInTransition } from '../transitions/transitions';
import StyledTappable from '../common/StyledTappable';

import pdfIcon from '../../images/consultations/new-flow/pdf-icon.svg';
import photoIcon from '../../images/consultations/new-flow/camera-icon.svg';
import galleryIcon from '../../images/consultations/new-flow/gallery-icon.svg';
import followUpIcon from '../../images/consultations/new-flow/follow-up-icon.svg';

const ModalContainer = styled.div`
  height: 100svh;
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
`;

const AttachOptionsContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 1rem;
  border-bottom: 1px solid rgba(240, 243, 246, 1);
`;

const AttachOption = styled(StyledTappable)`
  display: flex;
  flex: 1;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  margin: 0 0.25rem;
`;

const AttachOptionInnerContainer = styled.div`
  display: flex;
  flex: 1;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem;
  background-color: white;
  overflow: hidden;
`;

const AttachOptionText = styled.div`
  font-size: ${() => `${0.75 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  text-align: center;
  font-weight: 600;
  color: #47464a;
  line-height: 14.63px;
  margin-top: 0.75rem;
`;

export class UploadModal extends Component {
  state = {
    showUploadOption: true,
  };
  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.setState({
      showUploadOption: false,
    });
    setTimeout(this.props.hideModal, 200);
  };

  onAttachPhoto() {
    document.querySelector('#photoAttachment').click();
  }

  onAttachFile() {
    document.querySelector('#fileAttachment').click();
  }

  onAttachCapture() {
    document.querySelector('#captureAttachment').click();
  }

  render() {
    const { showUploadOption } = this.state;

    return (
      <Modal>
        <ModalContainer onClick={this.handleOutsideClick}>
          <FadeInTransition
            in={showUploadOption}
            mountOnEnter
            unmountOnExit
            onExited={this.props.hideModal}
            appear
          >
            <div
              className="bg-textbox rounded-12 mx-16px"
              ref={(node) => (this.node = node)}
            >
              <div
                className="py-24px px-28px rounded-12 flex items-center justify-center"
                style={{ background: '#F4F1F9' }}
              >
                <p className="text-body-l font-semibold text-txtlight">
                  Please select an option
                </p>
              </div>
              <div>
                <AttachOptionsContainer>
                  <AttachOption
                    onTap={() => this.props.handleAttachment('pdf')}
                  >
                    <AttachOptionInnerContainer>
                      <img src={pdfIcon} alt="upload-pdf" />
                      <AttachOptionText>PDF</AttachOptionText>
                    </AttachOptionInnerContainer>
                  </AttachOption>
                  <AttachOption
                    onTap={() => this.props.handleAttachment('gallery')}
                  >
                    <AttachOptionInnerContainer>
                      <img src={galleryIcon} alt="upload" />
                      <AttachOptionText>Gallery</AttachOptionText>
                    </AttachOptionInnerContainer>
                  </AttachOption>
                  {this.props.hideCamera === true ? null : (
                    <AttachOption
                      onTap={() => this.props.handleAttachment('camera')}
                    >
                      <AttachOptionInnerContainer>
                        <img src={photoIcon} alt="click" />
                        <AttachOptionText>Camera</AttachOptionText>
                      </AttachOptionInnerContainer>
                    </AttachOption>
                  )}
                  {this.props.hideBookAnother === true
                    ? null
                    : !this.props.fromHCP &&
                      !this.props.fromRedirector && (
                        <AttachOption
                          onTap={() => this.props.handleAttachment('follow')}
                        >
                          <AttachOptionInnerContainer>
                            <img src={followUpIcon} alt="follow-up" />
                            <AttachOptionText>
                              Schedule Follow-up
                            </AttachOptionText>
                          </AttachOptionInnerContainer>
                        </AttachOption>
                      )}

                  {/* <AttachOption onTap={() => this.onAttachFile()}> */}
                  {/* <AttachOption onTap={() => this.onAttachCapture()}>
                    <AttachOptionInnerContainer>
                      <img src={cameraIcon} alt="click-pic" />
                      <AttachOptionText>Camera</AttachOptionText>
                    </AttachOptionInnerContainer>
                  </AttachOption> */}
                </AttachOptionsContainer>
                <div className="flex items-center justify-center px-28px pt-16px pb-24px">
                  <div className="bg-buttonLight w-4 h-4 flex justify-center items-center mr-8px">
                    <span
                      style={{
                        color: '#6544C6',
                        fontSize: '10px',
                      }}
                    >
                      i
                    </span>
                  </div>
                  <div className="text-chip">
                    Please make sure the document you upload is not cropped,
                    blurred, or blank
                  </div>
                </div>
              </div>
            </div>
          </FadeInTransition>
        </ModalContainer>
      </Modal>
    );
  }
}

export default UploadModal;
